import React from 'react';
import _ from 'lodash';
import { Box, Drawer, Button } from '@mui/material';
import { DebounceInput } from 'react-debounce-input';
import { useResponsive } from '../../../../services/hooks';
import { NAVBAR } from '../../../../utils/config';
import Scrollbar from '../../../../components/Scrollbar';
import { CssTextField } from '../../../../components/others/CssTextField';
import { SmallFormDateField } from '../../../../components/small-fields/SmallFormDateField';
import { formatDate } from '../../../../services/functions';
import dayjs from 'dayjs';

export const BankStatementsSidebar = props => {
  const { isOpenSidebar, onCloseSidebar, queryCallback } = props;
  const isDesktop = useResponsive('up', 'md');
  const [issueDateFrom, setIssueDateFrom] = React.useState(dayjs().subtract(10, 'day')
    .format('YYYY-MM-DD'));
  const [issueDateTo, setIssueDateTo] = React.useState('');
  const [value, setValue] = React.useState('');

  const resetFilters = () => {
    setIssueDateFrom(null);
    setIssueDateTo(null);
    setValue('');
  };

  React.useEffect(() => {
    let search = '?';
    if (!_.isEmpty(value)) {
      search += `search=${value}&`;
    }
    if (!_.isEmpty(issueDateFrom)) {
      search += `issue_date_from=${issueDateFrom}&`;
    }
    if (!_.isEmpty(issueDateTo)) {
      search += `issue_date_to=${issueDateTo}&`;
    }
    queryCallback(search);
  }, [issueDateFrom, issueDateTo, value]);


  const renderContent = (
    <Scrollbar sx={{ maxHeight: 800 }}>
      <Box sx={{ p: 1, pr: '32px' }}>
        <Button
          variant="contained"
          sx={{ mb: 4 }}
          onClick={resetFilters}
          fullWidth
        >
        Zresetuj filtry
        </Button>
        <DebounceInput
          debounceTimeout={1000}
          sx={{ width: '100%', mb: 2 }}
          element={CssTextField}
          placeholder="Szukaj..."
          label="Szukaj nazwy pliku"
          value={value}
          onChange={e => setValue(e.target.value)
          }
          variant="standard"
        />
        <SmallFormDateField
          sx={{ width: '100%', mb: 2 }}
          name="issue_date_from"
          type="text"
          label="Data utworzenia od"
          variant="standard"
          value={issueDateFrom}
          onChange={val => setIssueDateFrom(formatDate(val))}
        />
        <SmallFormDateField
          sx={{ width: '100%', mb: 2 }}
          name="issue_date_to"
          type="text"
          label="Data utworzenia do"
          variant="standard"
          value={issueDateTo}
          onChange={val => setIssueDateTo(formatDate(val))}
        />
      </Box>
    </Scrollbar>
  );

  return (
    <>
      {isDesktop ? (
        <Drawer variant="permanent" PaperProps={{ sx: { width: NAVBAR.BASE_WIDTH + 20, position: 'relative' } }}>
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: { width: NAVBAR.BASE_WIDTH } }}
        >
          {renderContent}
        </Drawer>
      )}
    </>
  );
};
